export const EXSBPAYMENTWAY_SHOW_RESET = 'EXSBPAYMENTWAY_SHOW_RESET'
export const EXSBPAYMENTWAY_SHOW_SET_ERROR = 'EXSBPAYMENTWAY_SHOW_SET_ERROR'
export const EXSBPAYMENTWAY_SHOW_SET_RETRIEVED = 'EXSBPAYMENTWAY_SHOW_SET_RETRIEVED'
export const EXSBPAYMENTWAY_SHOW_TOGGLE_LOADING = 'EXSBPAYMENTWAY_SHOW_TOGGLE_LOADING'
